import { ReportProfileResource } from '../profile/report-profile-resource';

export class ReportProfileValidateModel {
  isValid: boolean;
  userActivityIsValid: boolean;
  resources: ReportProfileResource[];
}
